__turbopack_context__.v({
  "body": "jpLnJW_body",
  "btn": "jpLnJW_btn",
  "close": "jpLnJW_close",
  "description": "jpLnJW_description",
  "footer": "jpLnJW_footer",
  "footerBtns": "jpLnJW_footerBtns",
  "icon": "jpLnJW_icon",
  "iconContainer": "jpLnJW_iconContainer",
  "root": "jpLnJW_root",
  "title": "jpLnJW_title",
});
